(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wrights-brand-directory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wrights-brand-finder')) {
    customElements.define('wrights-brand-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const input = this.querySelector('input');
        const details = this.querySelector('details');
        const items = Array.from(this.querySelectorAll('[data-brand-name]'));
        const empty = this.querySelector('[role="status"]');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/ß/g, 'ss').replace(/[^a-z0-9]/g, '');
        input.addEventListener('input', () => {
          const query = normalize(input.value);
          let visible = 0;
          items.forEach(item => {
            item.hidden = !normalize(item.dataset.brandName).includes(query);
            if (!item.hidden) visible++;
          });
          empty.hidden = visible > 0;
          if (query) details.open = true;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
